import { Component, Shark } from "shark-mvc";
import templateContent from "../../_shark_templates/components/pager.html";

class PagerComponent extends Component {
	constructor () {
		super("pagerComponent");
		this.addTemplate("", templateContent);
	}

	
	beforeRender () {
		const pageButtonsCount = 15;
		const middlePageIndex = Math.floor(pageButtonsCount / 2);
		const totalItemCount = this.get("totalItemCount");
		const currPage = this.get("currPage");
		const pageSize = this.get("pageSize");
		const pageCount = Math.ceil(totalItemCount / pageSize);
		const pages = [];
		let firstPage = Math.max(0, currPage - middlePageIndex);
		const lastPage = firstPage + pageButtonsCount;

		if (pageCount - firstPage < pageButtonsCount) {
			firstPage = Math.max(0, pageCount - pageButtonsCount);
		}

		for (let i = firstPage; i < Math.min(lastPage, pageCount); i++) {
			pages.push({
				isActive: i === currPage,
				label: i + 1,
				page: i
			});
		}

		this.set({
			isFirstPage: currPage === 0,
			isLastPage: currPage === pageCount - 1,
			lastPage: pageCount - 1,
			pages: pages,
			__showPager: totalItemCount > pageSize
		});
	}

	getRange () {
		const currPage = this.get("currPage");
		const pageSize = this.get("pageSize");

		return {
			first: currPage * pageSize,
			length: pageSize
		};
	}

}

const pagerComponent = new PagerComponent();

Shark.registerComponent(pagerComponent);

export { pagerComponent };